export default __webpack_public_path__ + "static/media/droneTutorial.78cc7aa8.svg";